import { module } from 'modujs';
import { isDebug } from '../utils/environment';

/**
 * Form Load
 *
 * On submit, customize the page transition animation.
 *
 * This only works with GET requests.
 */
export default class extends module {
    /**
     * @param {Object} m - The module options.
     */
    constructor(m) {
        super(m);

        this.events = {
            submit: 'handleSubmit'
        };
    }

    /**
     * @param {Event} event - The submit event.
     */
    handleSubmit(event) {
        event.preventDefault();

        // Can't use real `formData` because of IE11 so we parse it manually
        let formData = {}
        for(let input of Array.from(this.el)) {
            if(input.tagName != 'BUTTON') {
                formData[input.name] = input.value
            }
        }

        const search   = new URLSearchParams(formData);

        const url = window.location.origin + window.location.pathname + '?' + search;
        const transition = this.getData('transition');

        isDebug && console.log('[App.FormLoad] Submitting…')
        this.call('goTo', { url, transition }, 'Load');
    }
}
